// extracted by mini-css-extract-plugin
export default {"content":"index_content_9k5gv"};